import { render, staticRenderFns } from "./SImageUploader.vue?vue&type=template&id=89a7b6bc&scoped=true&"
import script from "./SImageUploader.vue?vue&type=script&lang=js&"
export * from "./SImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./SImageUploader.vue?vue&type=style&index=0&id=89a7b6bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a7b6bc",
  null
  
)

export default component.exports